import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IPieChartStyles {
  pieChartRoot?: IStyle;
  pieChartContainer?: IStyle;
  overlayContainer?: IStyle;
  overlayText?: IStyle;
  overlayErrorText?: IStyle;
  loadingSpinner?: IStyle;
  customTooltip?: IStyle;
  tooltipHeader?: IStyle;
  tooltipHeaderButton?: IStyle;
  tooltipContent?: IStyle;
  tooltipItem?: IStyle;
  tooltipLabel?: IStyle;
  tooltipValue?: IStyle;
}

export const pieChartStylesDefault = (theme: IH2OTheme): Partial<IPieChartStyles> => ({
  pieChartRoot: {
    display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
  },
  pieChartContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(243, 244, 246, 0.7)',
    zIndex: 1,
  },
  overlayText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.gray500,
  },
  overlayErrorText: {
    fontSize: '18px',
    fontWeight: 600,
    color: theme.palette?.red400,
  },
  customTooltip: {
    backgroundColor: theme.palette?.white || '#ffffff',
    border: `1px solid ${theme.palette?.gray200 || '#e1e1e1'}`,
    borderRadius: '4px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    minWidth: '200px',
    maxWidth: '300px',
    fontSize: '12px',
  },
  tooltipHeader: {
    padding: '8px 12px',
    backgroundColor: theme.palette?.gray500 || '#f8f9fa',
    borderBottom: `1px solid ${theme.palette?.gray200 || '#e1e1e1'}`,
    fontWeight: 600,
    color: theme.palette?.gray800 || '#323130',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tooltipHeaderButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    lineHeight: 1,
  },
  tooltipContent: {
    maxHeight: '200px',
    overflowY: 'auto',
    padding: '4px 0',
  },
  tooltipItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 12px',
    selectors: {
      '&:hover': {
        backgroundColor: theme.palette?.gray200 || '#f3f2f1',
      },
    },
  },
  tooltipLabel: {
    color: theme.palette?.gray700 || '#605e5c',
    marginRight: '8px',
    flex: 1,
  },
  tooltipValue: {
    color: theme.palette?.gray900 || '#201f1e',
    fontWeight: 500,
  },
});
